// extracted by mini-css-extract-plugin
export default {"offer-block":"styles_offer-block__uNVLf","offer-block__cards-wrapper":"styles_offer-block__cards-wrapper__DSJTT","offer-block__card":"styles_offer-block__card__gAEDp"};